const FEATURED_CONTENT_DATA = [
  {
    fBoxImage:
      "https://user-images.githubusercontent.com/60150901/118854685-9832e200-b8f2-11eb-8de4-2a40a1edaa06.jpg",
    fBoxStoryHead: "ADVANCED WORKOUT",
    fBoxText:
      "Caliathletics program focuses on developing a solid calisthenics strength foundation along with calisthenics skills and elite level exercises. The ultimate goal of the program is to help you develop an athletic and healthy physique, real body control and eventually higher self-confidence.",
  },
  {
    fBoxImage:
      "https://user-images.githubusercontent.com/60150901/118854676-96691e80-b8f2-11eb-9b88-07b33b76e579.jpg",
    fBoxStoryHead: "STRETCHING WORKOUT",
    fBoxText:
      "This program, which is divided into 3 types – a full mobility routine followed by a complete stretching routine – flexibility, mobility and, most of all, to become a better Calisthenics performer. This program will get rid of your muscle stiffness, pains and eventually bring back your good posture.",
  },
  {
    fBoxImage:
      "https://user-images.githubusercontent.com/60150901/118854944-e21bc800-b8f2-11eb-84fa-7bef9a379482.png",
    fBoxStoryHead: "NUTRITION GUIDE",
    fBoxText:
      "Nutrition plays a major role in achieving a dream physique, feeling healthy and even improving your sport performance! It will completely revise your past understanding of nutrition and all the myths you’ve believed in before. All the information will be explained in videos and also in the full E-book.",
  },
];

export default FEATURED_CONTENT_DATA;
